import './scss/vitrine.scss'
import { AreaComprar } from './components/AreaComprar'
import { Counter } from './components/Counter'
import type { VitrineTipo2Props } from '../types/vitrineApp.props'
import { MidiaProdutoVitrine } from '../components/MidiaProdutoVitrine'


export function RenderVitrineTipo2({
    produtos,
    exibeQuantidadeEstoqueVitrine,
    validaEstoqueVitrine,
    exibeValoresSomenteLogado,
    naoExibeNomeDerivacao,
    precoPrincipal,
    tituloVitrine,
    hoverImagensVitrine,
    hoverImagensVitrineMobile,
    width,
    height
}: VitrineTipo2Props) {
    return (
        <>  
            {tituloVitrine && (
                <div className="title-ctn">
                    <h2 className="bg-title">
                        <span dangerouslySetInnerHTML={{ __html: tituloVitrine }} />
                    </h2>
                </div>
            )}
            <div className="container">
                <div className="macro-produtos-colunas">
                    {Object.values(produtos).filter(produto => !validaEstoqueVitrine || (produto.qtde_estoque ?? 0) > 0).map((produto, index) => {
                        const aClass = index % 2 === 0 ? 'product-one-of-two' : 'product-two-of-two last'

                        return (
                            <div className={`product ${aClass}`}>
                                <a href={`/${produto.link}`}>
                                    <div className="conteudo-box">
                                        <div className="img-product">
                                            <MidiaProdutoVitrine
                                                produto={produto}
                                                width={width}
                                                height={height}
                                                hoverImagensVitrine={hoverImagensVitrine}
                                                hoverImagensVitrineMobile={hoverImagensVitrineMobile}
                                            />
                                        </div>

                                        <div className="conteudo-product">
                                            <h3 className="name-product">
                                                {produto.titulo || produto.nome}{" "}
                                                {!naoExibeNomeDerivacao && produto.derivacao_nome}
                                            </h3>

                                            <AreaComprar
                                                produto={produto}
                                                precoPrincipal={precoPrincipal}
                                                exibeValoresSomenteLogado={exibeValoresSomenteLogado}
                                            />
                                        </div>
                                    </div>

                                    <Counter
                                        dataFim={produto.data_fim ?? ''}
                                        qtdeEstoque={produto.qtde_estoque}
                                        exibeQuantidadeEstoqueVitrine={Boolean(exibeQuantidadeEstoqueVitrine)}
                                    />
                                </a>
                            </div>
                        )
                    })}
                </div>
            </div>
        </>
    )
}

